module.exports = __webpack_public_path__ + "static/media/DWFavicon.51f34d04.png";